import { render, staticRenderFns } from "./PreviewProductList.vue?vue&type=template&id=24658bba&scoped=true&"
import script from "./PreviewProductList.vue?vue&type=script&lang=js&"
export * from "./PreviewProductList.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProductList.vue?vue&type=style&index=0&id=24658bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24658bba",
  null
  
)

export default component.exports